import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectCurrentToken } from "../features/slices/authSlice";
import { useGetUnreadCountQuery } from "../features/api/notificationApiSlice";

/**
 * Convenience hook that returns unread notification counts.
 * Only fetches when the user is authenticated.
 * Polls every 60 seconds as a fallback when WebSocket is disconnected.
 *
 * @returns {{ counts: object|null, totalUnread: number, isLoading: boolean }}
 */
const useNotificationCount = () => {
  const token = useSelector(selectCurrentToken);

  const { data, isLoading } = useGetUnreadCountQuery(undefined, {
    skip: !token,
    pollingInterval: 60000,
  });

  const counts = data?.result || null;

  const totalUnread = useMemo(() => {
    if (!counts) return 0;
    return Object.values(counts).reduce((sum, val) => sum + (val || 0), 0);
  }, [counts]);

  return { counts, totalUnread, isLoading };
};

export default useNotificationCount;
